// This file is auto-generated. Do not edit!

export default [
  {
    name: "BPT-rETH-ETH",
    id: "0",
    bpt: "0x4Fd63966879300caFafBB35D157dC5229278Ed23",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x9Bcef72be871e61ED4fBbc7630889beE758eb81D",
        symbol: "rETH",
      },
    ],
    rewarder: "0x61ac9315a1Ae71633E95Fb35601B59180eC8d61d",
  },
  {
    name: "BPT-RESERVE",
    id: "1",
    bpt: "0x1D95129c18a8c91C464111FDf7d0Eb241B37a985",
    tokens: [
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
      {
        address: "0xc5b001DC33727F8F26880B184090D3E252470D45",
        symbol: "ERN",
      },
    ],
    rewarder: "0xD292f1813D5CAdCec37B0F1Dd27C74f0b10DfF7C",
  },
  {
    name: "BPT-ROAD",
    id: "5",
    bpt: "0x39965c9dAb5448482Cf7e002F583c812Ceb53046",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x4200000000000000000000000000000000000042",
        symbol: "OP",
      },
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
    ],
    rewarder: "0x823BF74Ae111822f1b013884B367E39c6e92358F",
  },
  {
    name: "ECLP-wstETH-WETH",
    id: "6",
    bpt: "0x7Ca75bdEa9dEde97F8B13C6641B768650CB83782",
    tokens: [
      {
        address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb",
        symbol: "wstETH",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
    rewarder: "0x9f43f726dF654E033B04c39989af90ab44875fEB",
  },
  {
    name: "bpt-stablebeets",
    id: "10",
    bpt: "0x9Da11Ff60bfc5aF527f58fd61679c3AC98d040d9",
    tokens: [
      {
        address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
        symbol: "USDC",
      },
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
      {
        address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
        symbol: "USDT",
      },
      {
        address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
        symbol: "DAI",
      },
    ],
    rewarder: "0x2e3CD130F5166AfdA2Cb0A2714F60e218D2A3643",
  },
  {
    name: "BPT-OPARA",
    id: "16",
    bpt: "0x0244B0025264dC5f5c113d472D579C9c994A59CE",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000042",
        symbol: "OP",
      },
      {
        address: "0xd3594E879B358F430E20F82bea61e83562d49D48",
        symbol: "PSP",
      },
    ],
    rewarder: "0x2bf59C2C2e8F26738Ad3F9eB3C8e85598a4a4C34",
  },
] as const
